import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import FecontestPage from "./FeContestPage"; // Import the ParamsPage component
import FeQrCodePage from "./FeQrCodePage";
// import FecontestPage1 from './FeContestPage1';
import { ToastProvider } from "./hooks/ToastContext";
import { LoaderProvider } from "./hooks/LoaderContext";
import { CookiesProvider } from 'react-cookie';
function App() {
  //   useEffect(() => {

  //    alert(id);

  // }, [id]);

  return (
    <>
     <CookiesProvider>
      <LoaderProvider>
        <ToastProvider>
          <Router>
            <Routes>
              {/* Define route with optional param2 */}
              <Route
                path="/"
                element={<FecontestPage />}
              />
              <Route
                path="/:cid/:viralMemberId?"
                element={<FecontestPage />}
              />
              <Route
                path="qr/:id"
                element={<FeQrCodePage />}
              />
              {/* <Route path="/test/:id" element={<FecontestPage1 />} /> */}
            </Routes>
          </Router>
        </ToastProvider>
      </LoaderProvider>
      </CookiesProvider>
    </>
  );
}

export default App;
